import React from "react"
import { ButtonLoadingSeeker } from "@ui-seeker/core"

import { useUserSettingsProvider, useUserSettingsProviderValidator } from "../../../@hooks"


export default function UserSettingProviderDrawerSubmit() {
	const { isLoading, handleSubmitProviderFormData } = useUserSettingsProvider()
	const { isValid } = useUserSettingsProviderValidator()

	return <ButtonLoadingSeeker
		loading={isLoading}
		disabled={!isValid}
		onClick={handleSubmitProviderFormData}
	>
		Save
	</ButtonLoadingSeeker>
}